import React from "react";
import { Fragment } from "react";
import logo from "../Images/logo.png";

const Us = () => {
  return (
    <Fragment>
      <div className="container-fluid w-100 filter-darker">
        <div className="row g-0 py-3">
          <div className="col-lg-5 d-flex align-items-center">
            <video autoPlay loop muted className="w-100" style={{ maxHeight: "100vh" }}>
              <source
                src="https://cdn-media.f-static.net/uploads/8639442/normal_691349e1df815.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div className="col-lg-7">
            <div className="text-center d-flex flex-column align-items-center h-100 text-light p-4">
              <img src={logo} alt="Bella Unión Turismo" height="100" className="mb-5 mt-auto" />
              <h2>Bella Unión: Un Punto Estratégico en la Triple Frontera</h2>
              <p>
                Bella Unión, en el noroeste de Uruguay, se encuentra en la triple frontera con Argentina y
                Brasil, junto a los ríos Uruguay y Cuareim. Su ubicación estratégica la convierte en un punto
                clave de conexión entre los tres países. La Ruta Nacional 3 facilita el acceso al resto de
                Uruguay. Rodeada de paisajes fluviales y tierras agrícolas, la ciudad ofrece actividades como
                pesca y paseos en bote. Su economía depende de cultivos como la caña de azúcar.
              </p>
              <p>
                Bella Unión Turismo promueve el potencial de la región y sus alrededores, como Mones Quintela,
                Gomensoro, Colonia Palma y Baltasar Brum. Buscamos desarrollar el turismo ecológico y
                sostenible, respetando la esencia local. Invitamos a explorar su historia, conectar con su
                gente y descubrir otros destinos en Uruguay, fomentando el turismo responsable y auténtico.
                ¡Únete a esta aventura!
              </p>
              <h4 className="text-center mb-auto">¡Tu próxima aventura comienza aquí!</h4>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Us;
